module.exports = __webpack_public_path__ + "/login_ui/img/hn-f978cc1c57bba38ca7e1f242d71e89ac.svg";